import { Separator } from "@/components/ui/separator";
import { formattedDate, formattedTime, formatTimeAgo } from "@/lib/helper";
import { getUserActivities } from "@/services/Users.service";
import { useInfiniteQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";

const ActivityLog = ({ id }) => {
  const { data, isLoading, isFetching, refetch, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: ["userActivities"],
      queryFn: async ({ pageParam = 1 }) =>
        await getUserActivities(pageParam, id),
      getNextPageParam: (lastPage, pages) => {
        if (lastPage.length === 0) return undefined;
        return pages.length + 1;
      },

      refetchOnMount: true,
    });

  const dataArr = data?.pages?.map((page) => page.data.data.data).flat();
  const dataArr2 = data?.pages?.map((page) => page.data.data.meta).flat()[0];

  return (
    <div className="grid w-full">
      {isFetching ? (
        <div className="flex justify-center items-center">
          <Loader2 className="animate-spin" />
        </div>
      ) : (
        <div className="flex flex-col ">
          {dataArr?.map((event, index) => (
            <div
              key={index}
              className="flex gap-8 w-full items-center justify-start"
            >
              <div className="flex flex-col items-center h-full">
                <div className="w-[6px] h-[6px] rounded-full bg-primary" />
                <Separator orientation="vertical" className="h-20" />
              </div>
              <div className="flex flex-col gap-[6px] w-full h-full">
                <div className="flex gap-1 items-center justify-between">
                  <p className="text-sm text-primary-3">{event?.event}</p>

                  <span className="text-sm text-gray-70">
                    {formatTimeAgo(event?.createdAt)}
                  </span>
                </div>
                <p className="text-sm">
                  {event?.description?.split(" at ")[0]}
                  {" on "}
                  {formattedDate(event?.description?.split(" at ")[1])}{" "}
                  {formattedTime(event?.description?.split(" at ")[1])}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActivityLog;
